import React from 'react';
import { useNewVerificationPanelFlag } from 'shared/featureFlags';
import { VerificationMethodContainer } from './VerificationMethod';
import { VerificationMethodV2 } from './VerificationMethodV2';

const ABTestVerification: React.FC = () => {
	const newVerificationPanelFlag = useNewVerificationPanelFlag();

	return newVerificationPanelFlag?.value ? <VerificationMethodV2 /> : <VerificationMethodContainer />;
};

export default ABTestVerification;
